module.exports = __webpack_public_path__ + "img/kevin.2c6bc38b.jpg";